import apiClient from './api';

export const getLatestBriefing = async () => {
  try {
    const response = await apiClient.get('/api/daily-briefing');
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      throw new Error('No briefing available');
    }
    throw new Error(
      error.response?.data?.detail || 'Failed to fetch daily briefing'
    );
  }
};

export const getLatestBriefingConditional = async ({ etag } = {}) => {
  try {
    const config = {
      validateStatus: s => s === 304 || (s >= 200 && s < 300),
      ...(etag && { headers: { 'If-None-Match': etag } }),
    };
    const response = await apiClient.get('/api/daily-briefing', config);
    if (response.status === 304) {
      return { status: 304, etag, payload: null };
    }
    return {
      status: 200,
      etag: response.headers['etag'] ?? null,
      payload: response.data,
    };
  } catch (error) {
    // Reason: 404 = no briefing exists yet — maps to null payload, not an error state.
    if (error.response?.status === 404) {
      return { status: 200, etag: null, payload: null };
    }
    throw new Error(error.response?.data?.detail || 'Failed to fetch daily briefing');
  }
};

export const generateBriefing = async ({ force = false } = {}) => {
  try {
    const response = await apiClient.post('/api/daily-briefing/generate', null, {
      params: force ? { force: true } : {},
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || 'Failed to generate briefing'
    );
  }
};

export const saveItem = async (briefingId, themeIndex, section, itemIndex) => {
  try {
    const response = await apiClient.post(
      `/api/daily-briefing/${briefingId}/save-item`,
      { theme_index: themeIndex, section, item_index: itemIndex }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || 'Failed to save item'
    );
  }
};
